// extracted by mini-css-extract-plugin
export default {"header":"HomeLayout_header__Off5R","main":"HomeLayout_main__44jXP","activeNavItem":"HomeLayout_activeNavItem__0AXtE","inActiveNavItem":"HomeLayout_inActiveNavItem__9x3Av"};